export const ItemTypes = {
  IDEACARD: 'ideacard',
  ITINERARYCARD: 'itinerarycard',
  FRIENDCARD: 'friendcard',
  FOLDERCARD: 'foldercard',
};
